export const SEARCH_TEXT = "Search Hotels";
export const SEARCH_STAYS_TEXT = "Search Stays";
export const CHECK_IN = "Check-in";
export const CHECK_OUT = "Check-out";
